import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { PlayCircle as PlayCircleIcon } from "@mui/icons-material";
import { NoticeboardButton } from "../shared";

interface NoNoticesCardProps {
  onCreateNotice: () => void;
  onPlayVideo: () => void;
}

const NoNoticesCard: React.FC<NoNoticesCardProps> = ({ onCreateNotice, onPlayVideo }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        p: { xs: 3, sm: 4 },
        border: "1px solid",
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Box
        component="img"
        src="/home/nonotices.webp"
        alt="No notices illustration"
        loading="lazy"
        decoding="async"
        sx={{
          width: "100%",
          maxWidth: 300,
          height: "auto",
          objectFit: "contain",
          mb: 3,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 500,
          color: "text.primary",
          mb: 1,
        }}
      >
        No notices yet
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mb: 3,
        }}
      >
        Create your first notice in under 60 seconds. Your activity will appear here once you start
        communicating with parents.
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          justifyContent: "center",
        }}
      >
        <NoticeboardButton variant="primary" onClick={onCreateNotice}>
          Create Notice
        </NoticeboardButton>
        <Box
          onClick={(e) => {
            e.stopPropagation();
            onPlayVideo();
          }}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            color: "primary.main",
            "&:hover": { color: "primary.dark" },
            transition: "color 0.2s ease",
          }}
        >
          <PlayCircleIcon sx={{ fontSize: 32 }} />
        </Box>
      </Box>
    </Paper>
  );
};

export default NoNoticesCard;
